import styled from 'styled-components';

export const MainContent = styled.div`
  width: 468px;
  text-align: center;
`;

export const BoldWrapper = styled.b`
  color: ${(p) => p.theme.colors.text};
`;
